import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { SnackbarService } from '../../../../services/snackbar.service.js';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { S3File } from 'allai-admin-shared';
import { FileService } from '../../../../services/file-service.js';
import { PageLoaderService } from '../../../../services/page-loader.service.js';
import { environment } from '../../../../../environments/environment.js';

/** The survey answer page */
@Component({
	selector: 'app-appointment-files',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule
	],
	templateUrl: './appointment-files.component.html',
	styleUrl: './appointment-files.component.scss'
})
export class AppointmentFilesComponent implements OnInit, OnDestroy {

	dataSource: MatTableDataSource<S3File>;

	readonly displayedColumns: string[] = ['bucket', 'key'];

	/** Table on the page showing the organization */
	@ViewChild(MatTable)
	private table: MatTable<S3File>;

	constructor(
		private appointmentsService: AppointmentsService,
		private snackBarService: SnackbarService,
		private pageLoaderService: PageLoaderService,
		private fileService: FileService
	) {

		if(environment.name != "prod") {
			this.displayedColumns.push("download");
		}

	}

	ngOnInit() {
		this.dataSource = new MatTableDataSource<S3File>(this.appointmentsService.appointmentDetail.files??[]);
		this.table?.renderRows();
	}

	ngOnDestroy() {
	}

	async download(file: S3File) {

		this.pageLoaderService.showAndListen(
			this.fileService.download(file).catch((err: any) => {
				this.snackBarService.error("Error downloading file");
			}),
			`downloading ${file.key}`
		);
	}
}
